import i18n from 'l10n';
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import GroupModel from 'js/models/group.model';
import GroupsCollection from 'js/models/groups.collection';
import Template from 'js/templates/groups.tiles.hbs';
import InnerView from 'js/views/group.tile.view';
import {delegateEvent} from "../utils/event.delegator";
import {el, handles, on, tagName, template} from "../adapters/backbone-decorators";

import {_} from "backboneAdapter";

require('interfaceAdapter');
require('metroHelpers');

@el("#groups-container")
@tagName("span")
@template(Template)
class GroupsTilesView extends GenericView {
    constructor(options) {
        super(options);
        /* passing custom Element and template values
        * for using a custom template, or having the groups
        * getting loaded in a custom Html element
        * (ref: engagements.view.js)
        */
        if (options) {
            if (options.el) {
                this.setElement(options.el);
            }

            if (options.customTemplate) {
                this.Template = options.customTemplate;
            }

            // a flag that shows whether it is being used for all groups or for query ones only
            if (options.queryGroupsOnly) {
                this.queryGroupsOnly = options.queryGroupsOnly;
            }
        }
        this.inGroupsSearch = false;
        this.nonBlockedGroupsLength = 0;
        this.GroupView = InnerView;

        this.groupsCollection = new GroupsCollection();
        this.groupsCollection.bind("sync", () => {
            //renders the collection, after it gets the appropriate data,
            //pass null so `this.groupsCollection` will be used
            this.getAndUpdateGroupsCounters(null).then(() => console.log("Groups synced."));
        }, this);

        this.on("createQueryGroup", (groupname, query) => {
            let attrs = {
                title: i18n.t('groups.querygroup'),
                groupType: 'query',
                query: query
            };
            this.newGroupInner(attrs).then(x => console.log("Group created.", x));
        });

    }

    @handles("blockedChanged")
    load() {
        this.groupsCollection.fetch({
            error: function (model, status) {
                $.Notify.error(i18n.t("subscriber.nocontactsstatus") + ' = ' + status.status);
            }
        });
    }

    hide() {
        this.$el.parent().parent().hide();
    }

    show() {
        this.$el.parent().parent().show();
    }

    renderCollection(forSingleModel, forCollection) {
        // `forSingleModel` will be true, only when:
        //      A new group is created and we want to append it,
        //      without having to render (and do requests, before rendering) all of them.
        // `forCollection`<> NULL => a new group was created, so render only that one
        const collection = forCollection || this.groupsCollection;
        const hasNonBlockedGroups = this.nonBlockedGroupsLength && this.nonBlockedGroupsLength !== 0;

        if (forSingleModel) {
            // since we do not update the whole template, update the Groups' length value (contacts & groups page)
            $("#groupsCount").text(`(${this.groupsCollection.length})`);

            //show or hide searchbox, accordingly.
            $("#nogroupssearch").toggle(!hasNonBlockedGroups);
            $("#groupssearchbox").toggle(hasNonBlockedGroups);
        } else {
            // if used in engagement/satisfaction, calculate the correct collection count (shows count of all groups, rather than the count of only query ones)
            // calculate the count of the collection, taking into account, if only the query groups are being displayed or not
            const groupsLength = this.queryGroupsOnly ? collection.filter(m => m.get("groupType") == "query").length : collection.length;

            const tempTemplate = Handlebars.compile(Template)({
                "length": groupsLength,
                "hasNonBlockedGroups": hasNonBlockedGroups
            });
            this.$el.html(tempTemplate);
        }

        collection.each(model => this.renderModel(model));
        this.$('[data-i18n]').i18n();
    }

    async getAndUpdateGroupsCounters(singleModel) {
        try { // since `groupsCollection.on('sync')` does not fire but while fetching, the collection itself,
            // create a new groupsCollection and add the newly created model inside it,
            // so the requests that get its data (References, blocked count, QueryGroup members Count), will be executed for only this specific group
            let collection = singleModel ? new GroupsCollection([singleModel]) : this.groupsCollection;

            const queryGroups = collection.filter(m => m.get("query")).map(m => [m.get("id"), m.get("query")]);

            const referencedGroups = collection.map(m => `Group${m.get("id")}`);
            const groupIds = collection.map(x => x.get("id"));

            if (!this.inGroupsSearch) {
                this.nonBlockedGroupsLength = this.groupsCollection.length - 1;
            }
            // var hasNonBlockedGroups = this.nonBlockedGroupsLength != 0;
            this.referenced = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Config/references",
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(referencedGroups),
                dataType: 'json'
            });
            this.blockedCount = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Group/blockedCount",
                type: 'GET',
                contentType: 'application/json',
                traditional: true,
                data: {groupIds},
                dataType: 'json'
            });
            this.smsBounced = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Group/smsBounced",
                type: 'GET',
                contentType: 'application/json',
                traditional: true,
                data: {groupIds},
                dataType: 'json'
            });
            this.emailBounced = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Group/emailBounced",
                type: 'GET',
                contentType: 'application/json',
                traditional: true,
                data: {groupIds},
                dataType: 'json'
            });
            this.queryCount = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Subscription/CountByCriterion/many",
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(queryGroups)
            });

            this.updateCounts(collection, "emailBounced");
            this.updateCounts(collection, "smsBounced");
            this.updateCounts(collection, "blockedCount");

            // fill the, currently to be rendered, collection with their counts
            collection = this.createQueryGroupsAndTheirCounts(singleModel);

            this.renderCollection(singleModel != null, collection);
        } catch (e) {
            console.error(`Horryfying accident occured at ${this.constructor.name}::getAndUpdateGroupsCounters. Five dead and multiple casualties`)
        }
    }

    updateCounts(collection, attribute) {
        const counts = this[attribute];
        collection.forEach(function (model) {
            const countInfo = counts.find(tuple => model.get(model.idAttribute) === tuple[0]);
            const size = countInfo ? countInfo[1] : 0;
            model.set(attribute, size);
        });
    }

    createQueryGroupsAndTheirCounts(singleModel) {
        // if singleModel is not null, then update the counters of, only, the given model
        // or else, it will update the values of all other groups to `0`, due to it having data only for the `singleModel`
        const collection = singleModel ? new GroupsCollection([singleModel]) : this.groupsCollection;

        collection.filter(m => m.get('groupType') === "query").forEach(model => {

            const queryGroupInfo = this.queryCount.find(tuple => model.get(model.idAttribute) === parseInt(tuple[0]));

            const size = queryGroupInfo ? queryGroupInfo[1] : 0;
            model.set("size", size);
        });

        return collection;
    }

    renderModel(model, scroll) {
        const view = new this.GroupView({
            model,
            referenced: this.referenced[`Group${model.get(model.idAttribute)}`]
        });
        view.render();
        this.$el.find('#grouptiles').append(view.el);
        if (scroll) view.el.scrollIntoView();
    }

    @on('keyup .searchbox')
    dosearch() {
        const text = this.$el.find('.searchbox').val().toLowerCase();
        if (text.length > 0) {
            const [shown, hidden] = this.groupsCollection.partition(m => m.myText().includes(text));
            const found = shown.length;
            const modelToEl = model => this.$el.find(`#group-${model.get("id")}`);
            const toggler = (toggle, group) => group.toggle(toggle);

            shown.map(modelToEl).forEach(_.partial(toggler, true));
            hidden.map(modelToEl).forEach(_.partial(toggler, false));

            this.$el.find('.groups-count').text(`(${found})`);
            this.inGroupsSearch = true;
        } else {
            this.$el.find('.groups-count').text(`(${this.groupsCollection.length})`);
            this.$el.find('.tile').show();
            this.inGroupsSearch = false;
        }
    }

    @on('keydown #new-group-name')
    newGroupKeyDown(e) {
        if (e.which === 13) {
            this.newGroup();
        }
    }

    @on('click #new-group')
    newGroup() {
        let attrs = {
            title: $("#new-group-name").val(),
            groupType: "enum"
        };
        return this.newGroupInner(attrs);
    }

    async newGroupInner(attrs) {
        const model = new GroupModel(attrs);
        model.isNew = () => true;

        try {
            const response = await model.save();
            model.isNew = () => false;
            if (model.get("id")) {
                delegateEvent(model, this, "blockedChanged");
                this.groupsCollection.add(model);
                //used from another views, e.g. satisfaction.view, after creating a new group.
                //pass the newly created model, get its appropriate data and render it.
                await this.getAndUpdateGroupsCounters(model);
                $.Notify.show(i18n.t("instantWin.groupCreatedSuccessfully"));
            } else {
                $.Notify.error(`${i18n.t("instantWin.errorCreatingGroup")}. Outcome: ${response}`);
            }
        } catch (r) {
            $.Notify.error(i18n.t("instantWin.errorCreatingGroup"));
        }
    }
}

export default GroupsTilesView;
